/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";

function CashierCassettesFillingGrid({ requests }: { requests: any[] }) {
  const nf = Intl.NumberFormat();
  const residuals: any[] = [];
  const denominations: any[] = [];

  const notesTotals: any[] = [];

  requests.forEach((req) => {
    req.denominations.forEach((cst: any) => {
      const denom = denominations.find(
        (dnm) => dnm.denomination === cst.denomination
      );

      if (!denom) {
        denominations.push({ denomination: cst.denomination });
      }
    });

    const denomsFilled: any = {};

    if (req.denominations) {
      req.denominations.forEach((cn: any) => {
        denomsFilled[cn.denomination] = cn.notes;
      });
    } else {
      req.denominations.forEach((rep: any) => {
        denomsFilled[rep.denomination] = 0;
      });
    }

    const resInfo = {
      serialNo: req.serialNo,
      locationId: req.locationId,
      locationName: req.locationName,
      maker: req.maker,
      totalNotes: req.totalNotes,
      denomsFilled,
      remarks: req.remarks,
    };

    residuals.push(resInfo);

    notesTotals.push(denomsFilled);
  });

  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location Id
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location Name
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Maker
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Denominations Filled
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Bank Notes
            </th>

            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Remarks
            </th>
          </tr>
          <tr>
            {denominations.map((dnm, i) => {
              return (
                <th
                  // eslint-disable-next-line react/no-array-index-key
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {residuals.map((res, i) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={`row${i}`}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {res.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationId}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationName}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.maker}
                </td>

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      // eslint-disable-next-line react/no-array-index-key
                      key={`cn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.denomsFilled[denom]
                        ? nf.format(res.denomsFilled[denom])
                        : 0}
                    </td>
                  );
                })}

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.totalNotes ? nf.format(res.totalNotes) : 0}
                </td>

                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.remarks}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan={4}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Total
            </td>

            {denominations.length > 0 &&
              denominations.map((dnm, i) => {
                const denom = dnm.denomination;
                let total = 0;

                notesTotals.forEach((ct) => {
                  total += ct[denom] ? ct[denom] : 0;
                });
                return (
                  <td
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    style={{
                      border: "0.02rem solid grey",
                      fontSize: "0.7rem",
                      fontWeight: "bold",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    {nf.format(total)}
                  </td>
                );
              })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            />

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default React.memo(CashierCassettesFillingGrid);
